module.exports = __webpack_public_path__ + "static/media/tower.c7ea1a48.jpg";